/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { NenAllowList, NenAllowListInterface } from "../NenAllowList";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "bulkMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isTransferable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "minter",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_minter",
        type: "address",
      },
    ],
    name: "setMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newuri",
        type: "string",
      },
    ],
    name: "setURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleIsTransferable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenAllowListConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenAllowListConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenAllowList__factory extends ContractFactory {
  constructor(...args: NenAllowListConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenAllowList";
  }

  deploy(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenAllowList> {
    return super.deploy(uri_, overrides || {}) as Promise<NenAllowList>;
  }
  getDeployTransaction(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri_, overrides || {});
  }
  attach(address: string): NenAllowList {
    return super.attach(address) as NenAllowList;
  }
  connect(signer: Signer): NenAllowList__factory {
    return super.connect(signer) as NenAllowList__factory;
  }
  static readonly contractName: "NenAllowList";
  public readonly contractName: "NenAllowList";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenAllowListInterface {
    return new utils.Interface(_abi) as NenAllowListInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenAllowList {
    return new Contract(address, _abi, signerOrProvider) as NenAllowList;
  }
}
